<template>
	<div class="container"
    v-infinite-scroll="more"
    infinite-scroll-disabled="allLoaded"
    infinite-scroll-distance="10"
    >

<div class="row lb" v-if="all.lb&&all.lb.length>0" :style="imgstyle">
<mt-swipe :auto="5000">
  <mt-swipe-item v-for="v in all.lb" :key="v.id">
     <img :src="picurl+v.pic" :alt="v.title" @click="href(v.url)" :style="imgstyle">
  </mt-swipe-item>
</mt-swipe>
</div>

<div class="row mynav center" v-if="false">
  <div :class="{'col-33':width<=359,'col-25':width>359}">
      <router-link to="/user/person/1" class="fa fa-user"> 个检预约</router-link>
  </div>
  <div :class="{'col-33':width<=359,'col-25':width>359}">
      <router-link to="/user/team" class="fa fa-user-plus"> 团检预约</router-link>
  </div>
  <div :class="{'col-33':width<=359,'col-25':width>359}">
      <router-link to="/user/report" class="fa fa-book"> 报告查询</router-link>
  </div>
  <div class="col-25" v-if="width>359">
      <router-link to="/mall" class="fa fa-shopping-cart"> 健康商城</router-link>
  </div>
</div>

<div class="row mynav center">
 <small>
  <div class="col-25"><img src="../images/four/1.png" alt="诚信保证" style="top:.25rem;"> 品质保证</div>
  <div class="col-25"><img src="../images/four/2.png" alt="贴心服务"> 贴心服务</div>
  <div class="col-25"><img src="../images/four/3.png" alt="权威专业"> 权威专业</div>
  <div class="col-25"><img src="../images/four/4.png" alt="尊贵体验"> 尊贵体验</div>
 </small> 
</div>


<div class="row" v-if="all.dt">
  <h3 @click="topush('/thm/index/5')">
    <i class="leftblue"></i>
    <span class="a">公司动态</span>
    <span class="more">更多 <i class="fa fa-angle-right"></i></span>
  </h3>
</div>
<div class="row">
  <ul class="list">
    <router-link :to="'/thm/acticle/nid/'+v.nid+'/b/'+v.aid" class="item" v-for="(v,i) in all.dt" :key="v.aid">
     <div class="row bgray dt" v-if="i%2==0">
      <div class="col-3 img-box" :style="{backgroundImage:'url('+picurl+v.pic+')'}"></div>
      <div class="col-7">
        <h4 class="item-header">{{v.title}}</h4>
        <p class="item-footer">
        <span>阅读({{v.visit}})</span>
        <span class="time">{{v.time|date}}</span>
        </p>
      </div>
     </div> 

     <div class="row dt" v-if="i%2==1">
      <div class="col-7">
        <h4 class="item-header">{{v.title}}</h4>
        <p class="item-footer">
        <span>阅读({{v.visit}})</span>
        <span class="time">{{v.time|date}}</span>
        </p>
      </div>
      <div class="col-3 img-box" :style="{backgroundImage:'url('+picurl+v.pic+')'}"></div>
     </div> 
    </router-link>
  </ul>
</div>

<div class="row" @click="topush('/thm/team/n/16')" v-if="all.dt">
  <h3>
    <i class="leftblue"></i>
    <span class="a">医疗团队</span>
    <span class="more">更多 <i class="fa fa-angle-right"></i></span>
  </h3>
</div>

<div v-if="all.team&&all.team.length>0">
<div v-for="(v,i) in all.team" :key="v.id" >
<div class="row team left" v-if="i%2==0" @click="topush('/thm/doctor/d/'+v.id)">
  <div class="col-4">
    <div class="bblue">
       <img :src="picurl+v.pic" :alt="v.name"/>
    </div>
  </div>
  <div class="col-6">
    <div class="row"><b>{{v.name}}</b> <span class="gray zw">({{v.zw}})</span></div>
    <div class="row gray zy">{{v.zy}}...</div>
  </div>
</div>

<div class="row team right noborder" v-if="i%2==1" :key="v.id" @click="topush('/thm/doctor/d/'+v.id)">
  <div class="col-6">
    <div class="row"><b>{{v.name}}</b> <span class="gray zw">({{v.zw}})</span> </div>
    <div class="row gray zy">{{v.zy}}...</div>
  </div>
   <div class="col-4">
    <div class="bblue">
       <img :src="picurl+v.pic" :alt="v.name"/>
    </div>
  </div>
</div>

</div>	  
</div>


<div class="row" @click="topush('/mall')" v-if="all.dt">
  <h3>
   <i class="leftblue"></i>
    <span class="a">套餐推荐</span>
    <span class="more">更多 <i class="fa fa-angle-right"></i></span>
  </h3>
</div>

<div class="row good">
  <div class="col-5" v-for="v in all.mall" :key="v.id" @click="detail(v)">
    <img :src="picurl+v.big_pic" alt="商品图片"/>
    <h4>{{v.name}}</h4>
    <p class="pp">
    <span class="price">¥{{v.price/100}}</span>
    <span class="oprice">¥{{v.old_price/100}}</span>
    </p>
  </div>
</div>

<div class="row center" style="padding:1rem;" v-show="!allLoaded">
   <mt-button size="small" @click="more">点击查看更多</mt-button>
</div>


<div class="row tel"  v-if="all.dt"> 
  服务热线：400-1111-300
</div>

<div class="address"  v-if="all.dt">
版权所有(C) 深圳第一健康医疗管理有限公司 粤ICP备10240765号
</div>


</div>
</template>

<style scoped>
.container{
    transform: translateZ(0);
}
.bgray{background:rgb(248,248,248);}
.tel{background:rgb(250,250,250);color:#aaa;text-align:center;padding:.5rem 0 .3rem;margin-top: 2rem;font-size:12px;}
.address{width:100%;float:left;padding:0 0 .5rem 0; 
  font-style:normal;color:#aaa;font-size: 12px;
  text-align: center;background:rgb(250,250,250);
  margin:0;
}
/*.lb img{max-width: none;position: relative;left:-60%;} */
.lb img{width:100%;}

h3{font-size:22px;border-bottom: 1px solid #f7f7f7;padding:0;margin:.8rem .5rem .5rem;padding-bottom: .5rem;font-weight: 500;}
i.leftblue{display: inline-block;width:4px;height:24px;margin-right: .5rem;background:rgb(0,144,255);
  top: 3px;position: relative;}
.list{max-width: 100%;}
.mynav{padding:.3rem;border:1px solid #ddd;color:#aaa;}
.mynav .col-33{text-align: center;}
.mynav a{color:#aaa;}
.mynav img{top: .2rem;position: relative;}


h4{font-weight: 500;font-family: "微软雅黑";}
.item{height:120px;  display: flex;
    align-items:center;border:0;}
.list .item{padding:0 .5rem;}
.col-3{padding:0;height:110px;text-align: center;}
.col-3 img{max-width:100%;height:110px;}  
.item-header{height:42px;line-height:21px;text-overflow: ellipsis;overflow: hidden;padding:0 .5rem;}
.dt{padding:5px .1rem;}
.dt .time{float: right;}

.team{padding:.5rem .3rem;height:12rem;border-bottom: 1px solid #eee;position: relative;}
.team .bblue{background:rgb(0,144,255);width:7rem;height:9.6rem;position: absolute;}
.left .bblue{left:.5rem;}
.right .bblue{right:.5rem;}
.team img{width:7rem;height:8rem;position: absolute;top:.8rem;}
.left img{left:.8rem;}
.right img{right:.8rem;}
.team .col-6{padding:.5rem .8rem;}
.team .zy{padding-top: .6rem;}
.noborder{border:0;}

.good img{width:90%;margin:2% 5%;}
.title{font-size: 1.2rem;padding:.5rem;font-weight: 600;}
h4{height:3.3rem;overflow: hidden;font-weight: 500;}  
.price{color:red;font-size: 1.2rem;}
.oprice{color:#adadad;text-decoration:line-through;}
.pp{padding-left:.5rem;}
.more{float:right;color:#c7c7c7;font-weight: 300;font-size:1rem;position: relative;top:0.3rem;}
.more .fa{font-size: 1.5rem;position: relative;margin-left:.3rem;top:.15rem;}
.zw{font-size: .95rem;}
.img-box{overflow:hidden;background-size:auto 100%;background-repeat:no-repeat;background-position:center;}


</style>

<script>
import { InfiniteScroll } from 'mint-ui';

  export default {
    name: 'index',
    components:{InfiniteScroll},
    data:function(){
      return {
      	picurl:picurl,
        all:{
            count:0,
            dt:[],
            lb:[],
            mall:[],
            team:[],
        },
        allLoaded:false,
        width:320,
        imgstyle:{
          height:'160px'
        },
      } 	
    },
    created:function(){
       this.width=window.innerWidth;
       this.init();
    },
    mounted:function(){
       this.setStyle();
    },
    methods:{
      setStyle:function(){
        this.imgstyle={
          height:this.width*0.55+"px",
        }
      },
      init:function(){
        var _this=this;
        fun.post(api,{},function(d){
            console.log(d);
          if(d.status==1){
            _this.all=d.info;
            fun.cache(fun.url(),d.info);
          }else{
            _this.$toast(d.info);
          }
        })
      },
      href:function(url){
        if(!url){return;}
        var host=location.origin;
        var url=url.replace(host,"").replace(".html","");
         console.log(url);
        if(url){
          this.$router.push(url);
        }
      },
      more:function(){
        console.log("more")

        var data={
          len:this.all&&this.all.mall?this.all.mall.length:0,
        }
        var _this=this;
        fun.post(api+"index_more",data,function(d){
          console.log(d);
          if(d.status==1){
            _this.all.mall=_this.all.mall.concat(d.info);
            fun.cache(fun.url(),_this.all);
            if(d.info.length<8){_this.allLoaded=true;}
          }else{
            _this.$toast(d.info);
            _this.allLoaded=true;
          }
        })
      },
      detail:function(v){
         this.$router.push("/mall/detail/code/"+v.goods_code);
      },
      topush:function(url){
        this.$router.push(url);
      },
      err:function(v){
        v.pic="default.jpg";
      }
    }
    }	
</script>


// WEBPACK FOOTER //
// src/components/index.vue